import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import ContactPage from './components/ContactPage';
import { FiArrowUp } from 'react-icons/fi';
import './App.css';

function Home() {
  return (
    <div className="nada-page">
      <Header />
      <main>
        <div className="bg-watermark">
          <HeroCarousel />
          <Services />
        </div>
        <ContactForm />

        <div className="floating-buttons">
          <a href="https://chat.whatsapp.com/GL51u42DpiDC7cuu34eV6O" className="whatsapp-float pulse" target="_blank" rel="noreferrer">
            <img src="https://img.icons8.com/color/48/whatsapp.png" alt="WhatsApp" />
          </a>
          <a href="https://www.instagram.com/nadayoga_gracefulsoundliving?igsh=MWFldDZ3cDdvZTE0eA==¸" className="instagram-float pulse" target="_blank" rel="noreferrer">
            <img src="https://img.icons8.com/color/48/instagram-new--v1.png" alt="Instagram" />
          </a>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;